import { twMerge } from 'tailwind-merge';

interface TitleSectionProps {
  icon?: React.ReactNode;
  text: string | React.ReactNode;
  defaultIconClassName?: string;
}

export const TitleSection = ({
  icon,
  text,
  defaultIconClassName,
}: TitleSectionProps) => {
  return (
    <div className="flex items-center gap-2">
      {icon || (
        <i
          className={twMerge(
            'ki-filled text-purple-500 text-[26px]',
            defaultIconClassName
          )}
        />
      )}
      <div className="font-semibold">{text}</div>
    </div>
  );
};
